import { ProgressResponse, UserPoints } from 'src/api/me/types';
import type { IconName } from 'src/components/Icon';
import { Color } from 'src/utils/theme';
import { Activities } from 'src/components/MiniPlayer';

type PointKey = keyof Omit<UserPoints, 'totalPoints'>;
type ProgressKey = keyof ProgressResponse;

const activityPointsKey: Record<Activities, PointKey> = {
  learn: 'learnablePoints',
  immerse: 'contentMediaPoints',
  communicate: 'missionPoints',
};

const activityProgressKeys: Record<Activities, ProgressKey[]> = {
  learn: ['learnablesFullyGrownCount', 'learnablesTouchedButNotFullyGrownCount'],
  immerse: ['contentMediaWatched', 'contentMediaReplayed'],
  communicate: ['missionsCompleted', 'missionsReplayed'],
};

const activityIcons: Record<Activities, IconName> = {
  learn: 'learnFilled',
  immerse: 'videoLibraryFilled',
  communicate: 'communicateFilled',
};

const activityIconColors: Record<Activities, Color> = {
  learn: 'success40',
  immerse: 'error60',
  communicate: 'information50',
};

const activityBackgrounds: Record<Activities, Color> = {
  learn: 'success98',
  immerse: 'error98',
  communicate: 'information98',
};

export const mapResponseToProps = (
  progress: ProgressResponse,
  userPoints: UserPoints,
  supportedActivities: Activities[],
) => {
  return supportedActivities.map(activity => {
    return {
      key: activity,
      title: activityPointsKey[activity],
      icon: activityIcons[activity],
      iconColor: activityIconColors[activity],
      backgroundColor: activityBackgrounds[activity],
      points: userPoints[activityPointsKey[activity]],
      items: activityProgressKeys[activity].map(progressKey => ({
        value: progress[progressKey],
        description: progressKey,
      })),
    };
  });
};
